import { createFileRoute } from '@tanstack/react-router';
import { UserType } from '../../../types';
import { submissionRouteLoader } from '../../../utils/submission-route-loader';
import SurveySubmission from '../../../components/pages/survey-submission';

export const Route = createFileRoute('/$accountSlug/$submissionId/')({
  ...submissionRouteLoader(UserType.INITIAL_USER),
  component: SurveySubmission,
});
